import { Box } from '@material-ui/core';
import React from 'react';
import { Switches, SwitchProps } from 'mui-rff';
import IconCheckCircleFilled from '../Icons/IconCheckCircleFilled/IconCheckCircleFilled';
import IconCloseV2 from '../Icons/IconCloseV2/IconCloseV2';
import { useDefaultShopStyles } from '../../hooks/useDefaultShopStyles';

// Light design wrapper around the mui-rff `Switches` form field.
// Adds a checkmark for the enabled state and an 'x' for the disabled state.
export const FieldSwitch = (props: SwitchProps) => {
  const defaultShopStyles = useDefaultShopStyles();

  return (
    <Switches
      checkedIcon={
        <IconCheckCircleFilled height="17" width="17" color={defaultShopStyles.shopColor00} />
      }
      icon={
        <Box
          height="15px"
          width="15px"
          borderRadius="50%"
          bgcolor={defaultShopStyles.shopColor00}
          display="flex"
          alignItems="center"
          padding="2px"
        >
          <IconCloseV2 color={defaultShopStyles.shopColor100} />
        </Box>
      }
      color="default"
      {...props}
    />
  );
};
